export default "__VITE_ASSET__C_tcUGWb__"